import React from "react";

const Cross = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M21 3L3 21M21 21L3 3" />
    </g>
  </svg>
);

export default Cross;



// WEBPACK FOOTER //
// ./src/theme/icons/Cross.js